/**
 * 弹框公共组件
 */
var $ = require('jquery'),
    Handlebars = require('handlebars');

var defaultOptions = {
    mask: true,
    closeIcon: true,
    padding: '20px',
    refreshOnClose: false,
    landed:'qqqqq',
    projectId: getPathName()
};
function getPathName(){
    var pathArr = window.location.pathname.split('/');

    return pathArr[pathArr.length - 1];
}
Handlebars.registerHelper("include", function(content , data) {
    var html = content;
    return Handlebars.compile(html)(data);
});
var tpl =
    '<div class="clinks-dialog {{className}} none" style="padding: {{padding}}">' +
    '{{#if closeIcon}}' +
    '<span class="close">' +
    '<i class="iconfont icon-close"></i>' +
    '</span>' +
    '{{/if}}' +
    '<div class="content">' +
    '{{{include content .}}}' +
    '</div>' +
    '<div class="btns">' +
    '{{# btns}}' +
    '<span {{#if id}}id="dialog-{{id}}"{{/if}} class="btn{{#each btnClass}} {{.}}{{/each}}">' +
    '{{name}}' +
    '</span>' +
    '{{/ btns}}' +
    '</div>' +
    '</div>';

var tplFn = Handlebars.compile(tpl);

// 背景蒙版
function createMask() {
    if ($('.body-mask').length === 0) {
        $('body').append('<div class="body-mask none"></div>');
    }

    return $('.body-mask');
}

function createDialog(data) {
    var $d = $(tplFn(data));

    $('body').append($d);
    return $d;
}

function cerateSubContent(text) {
    var $yohoDialog = $('.yoho-dialog'),
        subContent = '<p class="sub-content">' + text + '</p>';

    if ($yohoDialog && $yohoDialog.length > 0) {
        $yohoDialog.find('.content').after(subContent);
    }
}

function Dialog(options) {
    var opt = $.extend({}, defaultOptions, options);
    var that = this,
        i;

    // 实现继承时，只返回实例，不生成html
    if (opt.inherit) {
        return this;
    }

    if (opt.mask) {
        that.$mask = createMask();
    }

    that.$el = createDialog(opt);


    if (opt.subContent) {
        cerateSubContent(opt.subContent);
    }

    if (opt.subContents) {
        for (i = opt.subContents.length - 1; i >= 0; i--) {
            cerateSubContent(opt.subContents[i]);
        }
    }

    // 绑定x关闭事件
    that.$el.find('.close').click(function() {
        that.close();
        if (options.refreshOnClose) {
            window.location.reload();
        }
    });

    // 绑定btn关闭事件
    that.$el.find('.btn-close').click(function() {
        that.close();
    });

    function bindBtnEvt(index) {
        that.$el.find('#dialog-' + opt.btns[index].id).on('click', function() {
            opt.btns[index].cb && opt.btns[index].cb();
        });
    }

    // 绑定按钮事件
    if (opt.btns) {
        for (i = 0; i < opt.btns.length; i++) {
            bindBtnEvt(i);
        }
    }
}

Dialog.prototype.close = function() {
    this.$mask && this.$mask.addClass('none');
    this.$el && this.$el.remove();
};

Dialog.prototype.show = function() {
    this.$mask && this.$mask.removeClass('none');
    this.$el && this.$el.removeClass('none').css({
        'margin-top': -this.$el.outerHeight() / 2,
        'margin-left': -this.$el.outerWidth() / 2
    });
    return this;
};

exports.Dialog = Dialog;

// Alert
function Alert(content) {
    var that = this;
    var option = {
        content: content,
        className: 'alert-dialog',
        btns: [
            {
                id: 'alert-sure',
                btnClass: ['alert-sure','btn-clinks-red-bg'],
                name: '确定',
                cb: function() {
                    that.close();
                }
            }
        ]
    };

    Dialog.call(this, option);
}

Alert.prototype = new Dialog({
    inherit: true
});
Alert.prototype.constructor = Alert;
exports.Alert = Alert;

// Confirm
function Confirm(opt) {
    var that = this;

    var option = {
        content: opt.content,
        className: 'confirm-dialog',
        btns: [
            {
                id: 'confirm-sure',
                btnClass: ['confirm-sure', 'btn-clinks-red-bg'],
                name: '确定',
                cb: opt.cb
            },
            {
                id: 'confirm-cancel',
                btnClass: ['confirm-cancel'],
                name: '取消',
                cb: function() {
                    that.close();
                }
            }
        ]
    };

    Dialog.call(this, option);
}

Confirm.prototype = new Dialog({
    inherit: true
});
Confirm.prototype.constructor = Confirm;
exports.Confirm = Confirm;



//////////////////
// WEBPACK FOOTER
// ./src/global/js/dialog.js
// module id = 11
// module chunks = 0 1 2 3